import React from "react";

export const SiteFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer">
      <div className="container text-center">
        <p className="footer-links">
          <span className="footer-brand">Echo MSG</span>
          <span aria-hidden="true"> | </span>
          <a href="/#contact">Help Center</a>
          <span aria-hidden="true"> | </span>
          <a href="/blog">Blog</a>
          <span aria-hidden="true"> | </span>
          <a href="https://www.linkedin.com/company/echo-msg/">LinkedIn</a>
          <span aria-hidden="true"> | </span>
          <a href="/privacy-policy">Privacy Policy</a>
          <span aria-hidden="true"> | </span>
          <a href="/terms-of-service">Terms of Service</a>
        </p>
        <p>&copy; {currentYear} Echo MSG.</p>
      </div>
    </footer>
  );
};
